/**
 * Kullanıcı etkinliği (klavye, fare, dokunma, kaydırma). Sunucu oturumu 15 dk hareketsizlikte kapatır; etkinlik
 * sekmeler arasında localStorage ile paylaşılır. Etkin olmayan kullanıcının istekleri (arka plan yoklamaları)
 * `X-Activity: passive` ile gider ve süreyi uzatmaz.
 */
export const IDLE_LIMIT_MS = 15 * 60_000
export const IDLE_WARN_MS = 2 * 60_000
/** Son bu süre içinde etkinlik varsa istek kullanıcı kaynaklı sayılır. */
const ACTIVE_WINDOW_MS = 60_000
const STORAGE_KEY = 'urunver.lastActivity'
const WRITE_EVERY_MS = 10_000

let last = Date.now()
let lastWrite = 0

function readShared(): number {
  try {
    return Number(window.localStorage.getItem(STORAGE_KEY)) || 0
  } catch {
    return 0
  }
}

export function markActivity(now = Date.now()) {
  last = now
  if (now - lastWrite < WRITE_EVERY_MS) return
  lastWrite = now
  try {
    window.localStorage.setItem(STORAGE_KEY, String(now))
  } catch {
    /* özel pencere / depolama kapalı: yalnız bu sekme */
  }
}

/** Bu ya da başka bir sekmedeki son etkinlik. */
export function lastActivity(): number {
  return Math.max(last, readShared())
}

export function isUserActive(now = Date.now()): boolean {
  return now - lastActivity() < ACTIVE_WINDOW_MS
}

export function resetActivity() {
  lastWrite = 0
  markActivity()
}
